var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBullet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 152.3 154.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffd15c;mix-blend-mode:screen;}.cls-2{isolation:isolate;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M149.49,73.35c-37.08,0-67.18-47.98-67.18-70.52,0-3.77-8.02-3.77-8.02,0,0,21.58-27.68,70.52-71.47,70.52-3.75,0-3.75,8,0,8,38.19,0,71.47,52.26,71.47,70.52,0,3.77,8.02,3.77,8.02,0,0-21.7,31.04-70.52,67.18-70.52,3.75,0,3.75-8,0-8Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullet);
export default __webpack_public_path__ + "static/media/bullet.5de044cb4c7c2cfaab25dc92cbb33d96.svg";
export { ForwardRef as ReactComponent };